module.exports = __webpack_public_path__ + "media/shoulder.a4527bca.mp4";